export const COLORS = {
  background: {
    light: "#FEFBF4",
    dark: "#09192B",
  },
  primary: {
    light: "#09192B",
    dark: "#FEFBF4",
  },
  primary700: {
    light: "rgba(9, 25, 43, 0.7)",
    dark: "rgba(255, 255, 255, 0.7)",
  },
  secondary: {
    light: "#D9BF65",
    dark: "#D9BF65",
  },
  borderColor: {
    light: "rgba(9, 25, 43, 0.09)",
    dark: "#D9BF65",
  },
  scrollbarColor: {
    light: "auto",
    dark: "var(--color-borderColor) var(--color-background)",
  },
  button: {
    light: "#09192B",
    dark: "#D9BF65",
  },
  buttonText: {
    light: "#FEFBF4",
    dark: "#09192B",
  },
  buttonHover: {
    light: "rgba(9, 25, 43, 0.93)",
    dark: "rgba(217, 191, 101, 0.9)",
  },
  modalBackground: {
    light: "#FEFEFE",
    dark: "#0E2845",
  },
  logoPrimaryColor: {
    light: "#09192B",
    dark: "#FEFBF4",
  },
  /* Below constants are used to display the prism.js theme.
   * For further reference see the globalStyles.js file.
   * */
  codeText: {
    light: "black",
    dark: "#f8f8f2",
  },
  textShadow: {
    light: "0 1px white",
    dark: "0 1px rgba(0, 0, 0, 0.3)",
  },
  codeTextShadowSelection: {
    light: "none",
    dark: "var(--color-textShadow)",
  },
  codeBackgroundSelection: {
    light: "#b3d4fc",
    dark: "var(--color-background)",
  },
  codeBorderRadius: {
    light: "0",
    dark: "0.3em",
  },
  codeBackground: {
    light: "#f5f2f0",
    dark: "#272822",
  },
  codeComment: {
    light: "slategray",
    dark: "#8292a2",
  },
  codePunctuation: {
    light: "#999",
    dark: "#f8f8f2",
  },
  codeTokenProperty: {
    light: "#905",
    dark: "#f92672",
  },
  codeTokenBoolean: {
    light: "var(--color-codeTokenProperty)",
    dark: "#ae81ff",
  },
  codeTokenSelector: {
    light: "#690",
    dark: "#a6e22e",
  },
  codeTokenOperator: {
    light: "#9a6e3a",
    dark: "#f8f8f2",
  },
  codeTokenOperatorBackground: {
    light: "hsla(0, 0%, 100%, .5)",
    dark: "none",
  },
  codeTokenVariable: {
    light: "#e90",
    dark: "#f8f8f2",
  },
  codeTokenAtrule: {
    light: "#07a",
    dark: "#e6db74",
  },
  codeTokenKeyword: {
    light: "#07a",
    dark: "#66d9ef",
  },
  codeTokenFunction: {
    light: "#DD4A68",
    dark: "#e6db74",
  },
  codeTokenRegex: {
    light: "#e90",
    dark: "#fd971f",
  },
};

export const TRANSITION_TIMES = {
  background: {
    light: "0s",
    dark: "0.75s",
  },
};

export const COLOR_MODE_KEY = "color-mode";
export const INITIAL_COLOR_MODE_CSS_PROP = "--initial-color-mode";
